import React from "react";

import styles from "./LabelWrapper.module.scss";

interface LabelWrapperProps {
  label: string;
  children: React.ReactNode;
  labelSuffix?: React.ReactNode;
  className?: string;
}

export function LabelWrapper({
  label,
  children,
  labelSuffix,
  className
}: LabelWrapperProps) {
  return (
    <div className={`${styles.labelWrapper} ${className || ""}`}>
      <label className={styles.label}>
        {label}
        {labelSuffix}
      </label>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
